import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Popup from 'reactjs-popup';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReactToPrint from 'react-to-print';

import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Moment from 'react-moment';
import moment from 'moment';
let strCust=[{title:'',year:0}];
const headCells = [
  	 { id: 'last_followup_date', numeric: false, label: 'Missed follow up date' },

  { id: 'ldm_firstname', numeric: false, label: 'Name' },
  { id: 'ldm_emailid', numeric: false, label: 'Email ID' },
  { id: 'ldm_phoneno', numeric: false, label: 'Phone No.' },
  { id: 'gender', numeric: false, label: 'Gender' },
    { id: 'ls_type', numeric: false, label: 'Status' },
  
    { id: 'ls_comments', numeric: false, label: 'Comments' },
	 { id: 'leadsource', numeric: false, label: 'Source' },
	 { id: 'attendedby', numeric: false, label: 'Attended By' },
   { id: '',  label: '' },
  ]
  const headCellstatus = [
{ id: '', numeric: false, label: '' },
{ id: 'followupdate', numeric: false, label: 'Followup Date' },

{ id: 'type', numeric: false, label: 'Type' },


]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
/*new table head for display payment*/
function EnhancedTableHeadstatus(props) {
	const { classes, order, orderBy, rowCount, onRequestSort } = props;
	const createSortHandler = property => event => {
	onRequestSort(event, property);
};

return (
<TableHead>
<TableRow>
        
{headCellstatus.map(headCell => (
<TableCell
key={headCell.id}
align={headCell.numeric ? 'right' : 'left'}
padding={headCell.disablePadding ? 'none' : 'default'}
sortDirection={orderBy === headCell.id ? order : false}
>
<TableSortLabel
active={orderBy === headCell.id}
direction={orderBy === headCell.id ? order : 'asc'}
onClick={createSortHandler(headCell.id)}
>
{headCell.label}
{orderBy === headCell.id ? (
<span className={useStyles.visuallyHidden}>
{order === 'desc' ? ' ' : ' '}
</span>
) : null}
</TableSortLabel>
</TableCell>
))}
</TableRow>
</TableHead>
);
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

/*new status section*/
EnhancedTableHeadstatus.propTypes = {
	classes: PropTypes.object.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};
/*end of new status section*/
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
const style = ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
});
export default class AdminLeadmaster extends Component {	
    constructor(props) {
    super(props);
   
   const now = dayjs();
const startOfMonth = now.startOf('month');
const today = now;
      this.state = {redirect: false,
      Leadfollowup:[],Leadexportfollowup:[],page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],ldcuid:0,
	 
	  order:'desc' ,orderBy:'',names:'',  
	// fromdate:dayjs(Date.now()),fromdate1:'',todate:dayjs(Date.now()),todate1:'',
	 fromdate: startOfMonth,
  fromdate1: startOfMonth.format('YYYY-MM-DD'),
  todate: today,
  todate1: today.format('YYYY-MM-DD'),
      };
       	   
	}
	
	componentDidMount  () {		
	document.title = "AthaYog Living - Lead FollowUp";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	 this.exportleadsApi();
  this.apicall(this.state.page,this.state.rowsPerPage);
  
} 

 handleClickSearch=()=>{ 
this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Leadfollowup:[],
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);
	this.exportleadsApi(); 
	}); 
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxleadmaster.php?action=missedfollowup&ldm_firstname='+this.state.names+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1)
     	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Leadfollowup: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
		    });
     }
	 else{
		   this.setState({Leadfollowup:[],totaldata:0});
	 }
 
    });
}

exportleadsApi(){
	 
	 axios.get(Serverurl+'ajaxleadmaster.php?action=missedfollowup&ldm_firstname='+this.state.names)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Leadexportfollowup: resp.data,  
			   	   

		    });

     }
	 else{
		   this.setState({Leadexportfollowup:[]});
	 }
 
    });
}



handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ fromdate:dayjs(date),
fromdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
todate: todate1,
todate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
	
  }
  handtodateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ todate:dayjs(date),
todate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
  formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  return (  
  <React.Fragment>
<div className="boxheading">
				 
<h2>Missed Follow-up</h2>
</div>

 <div className="clear"></div>

   <div className="searchmaster">


  
  <ul>
  
 <li>
 <p>Name/ Email id/ Phone No.</p>
 <p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Name"
            name="names" onChange={this.myChangeHandler} className="txtbox"
		
          /></p></li>	
		  
		  
		 	  
	  <li>
 <p>From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox" 
    onChange={this.handtodateChanges} format="DD/MM/YYYY"
	maxDate={dayjs()}
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li> 
		  
		<li><p>
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;&nbsp;
<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="leadmasterreport"
							filename="Lead Master Report"
							sheet="Lead Master Report"
							buttonText="EXPORT"/>&nbsp;&nbsp;	  
	  </p></li> 

		</ul>
		
</div>		

<div ref={el => (this.componentRef = el)}  >

<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>                                             
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Leadfollowup.length}
            />
                      <TableBody>
                     {Array.isArray(this.state.Leadfollowup) && stableSort(this.state.Leadfollowup, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >
 <TableCell>{this.formatDate(item.last_followup_date)}</TableCell>

<TableCell>{item.ldm_firstname}</TableCell>
<TableCell>{item.ldm_emailid}</TableCell>
<TableCell>{item.ldm_phoneno}</TableCell>
<TableCell>{item.gender}</TableCell>
<TableCell>{item.ls_type}</TableCell>
<TableCell>{item.ls_comments}</TableCell>
<TableCell>{item.leadsource}</TableCell>
<TableCell>{item.attendedby}</TableCell>

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
  component="div"  
  count={this.state.totaldata}  
  rowsPerPage={this.state.rowsPerPage}  
  page={this.state.page}  
  onPageChange={this.handleChangePage}  
  onRowsPerPageChange={this.handleChangeRowsPerPage}  
/>
  
  </Paper>
    </div>

<div style={{"display":"none"}}  >

<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="leadmasterreport">  
<TableHead> 
<TableRow>
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Leadexportfollowup.length}
            />
                      <TableBody>
                     {Array.isArray(this.state.Leadexportfollowup) &&stableSort(this.state.Leadexportfollowup, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >
 <TableCell>{item.last_followup_date}</TableCell>
<TableCell>{item.ldm_firstname}</TableCell>
<TableCell>{item.ldm_emailid}</TableCell>
<TableCell>{item.ldm_phoneno}</TableCell>
<TableCell>{item.gender}</TableCell>
<TableCell>{item.ls_type}</TableCell>
<TableCell>{item.ls_comments}</TableCell>
<TableCell>{item.leadsource}</TableCell>
<TableCell>{item.attendedby}</TableCell>

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
       
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onChangePage={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    </div>
 </React.Fragment> 

  );
}
}
